import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { notification } from "antd";
import { EditOutlined, CheckOutlined, CloseOutlined } from "@ant-design/icons";
import styles from "./style.module.scss";
import { apiRequest } from "util/services";
import { LoadingOutlined } from "@ant-design/icons";
import TopicDescriptionField from "./TopicDescriptionField";
import { useTranslation } from "react-i18next";

const ChildTopicPopup = ({
  setShowChildTopicPopup,
  selectedParentName,
  selectedChildInfo,
  setSelectedParentName,
  setSelectedChildInfo,
  selectedLanguage,
  onTopicRenamed,
}) => {
  const { t } = useTranslation();
  const theme = useSelector((state) => state.DashboardReducer.theme);
  const [childInfo, setchildInfo] = useState(false);
  const [popuploading, setPopupLoading] = useState(true);
  const [editingName, setEditingName] = useState(false);
  const [nameValue, setNameValue] = useState("");
  const [savingName, setSavingName] = useState(false);

  useEffect(() => {
    get_topic_info(selectedChildInfo?.id);
    setEditingName(false);
    setNameValue(selectedChildInfo?.name || "");
  }, [selectedChildInfo]);

  useEffect(() => {
    if (childInfo?.name) {
      setNameValue(childInfo.name);
    }
  }, [childInfo]);

  const get_topic_info = async (id) => {
    setPopupLoading(true);
    const payload = {
      lib_id: id,
    };
    const result = await apiRequest(
      "library/topic_info",
      "POST",
      payload,
      true
    );
    if (!result.error) {
      setchildInfo(result.success);
      setPopupLoading(false);
    } else {
      setPopupLoading(false);
    }
    setPopupLoading(false);
  };

  const saveName = async () => {
    const next = (nameValue || "").trim();
    const renameId =
      selectedChildInfo?.lang_tag_id || selectedChildInfo?.id;
    if (!next || !renameId) {
      setEditingName(false);
      return;
    }
    if (next === (childInfo?.name || selectedChildInfo?.name)) {
      setEditingName(false);
      return;
    }
    setSavingName(true);
    const result = await apiRequest(
      "library/custom_topics/rename",
      "POST",
      { topic_id: renameId, new_name: next },
      true
    );
    setSavingName(false);
    if (result?.error) {
      notification.error({
        message: result.error || "Failed to rename topic",
      });
      return;
    }
    setchildInfo((prev) => (prev ? { ...prev, name: next } : prev));
    setSelectedChildInfo((prev) => (prev ? { ...prev, name: next } : prev));
    if (typeof onTopicRenamed === "function") {
      // List identity is canonical id; name is language-specific.
      onTopicRenamed(selectedChildInfo.id, next);
    }
    setEditingName(false);
  };

  const displayName = childInfo?.name || selectedChildInfo?.name || "";

  return (
    <div className={styles.childTopicPopup}>
      <div className={styles.header}>
        <div className={styles.childInfo}>
          {selectedParentName && <span>{selectedParentName}</span>}
          {selectedParentName && <span className={styles.divider}>{">"}</span>}
          <span className={styles.activeChild}>
            {editingName ? (
              <span className={styles.nameEditRow}>
                <input
                  className={styles.nameEditInput}
                  value={nameValue}
                  onChange={(e) => setNameValue(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      saveName();
                    }
                    if (e.key === "Escape") {
                      setNameValue(displayName);
                      setEditingName(false);
                    }
                  }}
                  autoFocus
                  disabled={savingName}
                />
                <CheckOutlined
                  className={styles.nameEditAction}
                  onClick={saveName}
                />
                <CloseOutlined
                  className={styles.nameEditAction}
                  onClick={() => {
                    setNameValue(displayName);
                    setEditingName(false);
                  }}
                />
              </span>
            ) : (
              <span className={styles.nameDisplayRow}>
                {displayName}
                {(selectedChildInfo?.is_genai ||
                  selectedChildInfo?.hasModel ||
                  selectedChildInfo?.class_id != null) && (
                  <span
                    className={styles.genaiBadge}
                    title={t("topic_library.genai_tooltip")}
                  >
                    {t("topic_library.genai_badge")}
                  </span>
                )}
                <EditOutlined
                  className={styles.nameEditAction}
                  onClick={() => {
                    setNameValue(displayName);
                    setEditingName(true);
                  }}
                  title="Edit topic name"
                />
              </span>
            )}
          </span>
        </div>
        <img
          src={theme === "dark" ? "/assets/x.svg" : "/assets/x_black.svg"}
          alt=""
          onClick={() => {
            setShowChildTopicPopup(false);
            setSelectedChildInfo({});
          }}
        />
      </div>
      {popuploading ? (
        <LoadingOutlined color="white" style={{ color: "white" }} />
      ) : (
        <>
          <div className={styles.childContainer}>
            <div className={styles.topicRuleBlock}>
              <p className={styles.itemContentTitle}>Topic Description</p>
              <TopicDescriptionField
                topicId={selectedChildInfo?.id}
                language={selectedLanguage || "English"}
                readOnly={false}
                gap={0}
              />
            </div>
            {childInfo?.parent && childInfo?.parent?.length > 0 && (
              <div className={styles.tagLabelSmall}>
                <span>Parent's : </span>
                {childInfo?.parent?.map((item) => (
                  <span className={styles.tag} key={item.id || item.name}>
                    {item.name}
                  </span>
                ))}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default ChildTopicPopup;
